import {
  START_ALGO,
  UPDATE_ALGO,
  COMPLETE_ALGO,
  SET_ALGO_PREVIEW,
  RESET_ALGO,
  CANCEL_ALGO,
  SET_LAST_UPDATED,
} from "../types/algo";

const initialCompanyState = {
  progress: 0,
  running: false,
  algoId: null,
  creator: false,
  preview: false,
  elapsedTime: 0,
  completed: false,
  calledAt: null,
};

const initialState = {
  companies: {}, // Store state per company
  lastUpdated: null,
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case START_ALGO: {
      const { companyId, algoId, preview = true } = payload;
      return {
        ...state,
        companies: {
          ...state.companies,
          [companyId]: {
            ...initialCompanyState,
            running: true,
            preview,
            progress: 1,
            creator: true,
            algoId: algoId,
            calledAt: Date.now(),
          },
        },
      };
    }

    case UPDATE_ALGO: {
      const { companyId, progress, calledAt, algoId, creator } = payload;
      const company = state.companies[companyId] || initialCompanyState;
      return {
        ...state,
        companies: {
          ...state.companies,
          [companyId]: {
            ...company,
            running: true,
            algoId: algoId || company.algoId,
            creator: creator || company.creator,
            progress,
            calledAt: calledAt || company.calledAt,
          },
        },
      };
    }

    case COMPLETE_ALGO: {
      const { companyId } = payload;
      const company = state.companies[companyId] || initialCompanyState;
      if (!state.companies[companyId]) return state;
      return {
        ...state,
        companies: {
          ...state.companies,
          [companyId]: {
            ...company,
            running: false,
            progress: 0,
            preview: false,
            completed: true,
          },
        },
      };
    }

    case CANCEL_ALGO: {
      const { companyId } = payload;
      const company = state.companies[companyId] || initialCompanyState;
      if (!state.companies[companyId]) return state;
      return {
        ...state,
        companies: {
          ...state.companies,
          [companyId]: {
            ...company,
            running: false,
            progress: 0,
            preview: false,
            completed: true,
          },
        },
      };
    }

    case SET_ALGO_PREVIEW: {
      const { companyId, preview } = payload;
      const company = state.companies[companyId] || initialCompanyState;
      return {
        ...state,
        companies: {
          ...state.companies,
          [companyId]: {
            ...company,
            preview,
          },
        },
      };
    }

    case RESET_ALGO: {
      // Reset one company or all
      if (payload?.companyId) {
        const { [payload.companyId]: _, ...rest } = state.companies;
        return { ...state, companies: rest };
      }
      return initialState;
    }

    case SET_LAST_UPDATED: {
      return {
        ...state,
        lastUpdated: payload,
      };
    }

    default:
      return state;
  }
};

export default reducer;
